<div class="m-4">
  <formio
    [form]="form()"
    [submission]="submission()"
    (submit)="onSubmitForm($event)"
    (change)="onChangeForm($event)"
  ></formio>
</div>
